export const getInitials = (firstName: string, lastName: string) => {
  const first = firstName?.trim()?.charAt(0)?.toUpperCase() || "";
  const last = lastName?.trim()?.charAt(0)?.toUpperCase() || "";

  return first + last || ""; // Returns empty string if both are empty
};
